/**
 * Hộp "Chọn ngày": lịch tháng (tuần bắt đầu Chủ Nhật), chọn NHIỀU ngày, không cho chọn
 * ngày đã qua. `coDinh` là các ngày đã có (hiện đã chọn, không bỏ được ở đây).
 */
import { useId, useState, type ReactNode } from 'react';
import { dienVao } from '../ngon-ngu/vi';
import { viLichPhatThanh } from '../ngon-ngu/vi-lich-phat-thanh';
import { homNayVn, luoiThang } from '../man-hinh/lich-phat-thanh-tien-ich';

export function HopChonNgay({
  tieuDe,
  coDinh = [],
  onHuy,
  onXacNhan,
}: {
  tieuDe?: string;
  coDinh?: string[];
  onHuy: () => void;
  onXacNhan: (ngayMoi: string[]) => void;
}): ReactNode {
  const t = viLichPhatThanh.lich;
  const idTieuDe = useId();
  const homNay = homNayVn();
  const [nam0, thang0] = homNay.split('-').map(Number) as [number, number];
  const [nam, datNam] = useState(nam0);
  const [thang, datThang] = useState(thang0);
  const [chon, datChon] = useState<Set<string>>(new Set());
  const tapCoDinh = new Set(coDinh);

  const doiThang = (buoc: number): void => {
    const m = thang + buoc;
    if (m < 1) {
      datThang(12);
      datNam(nam - 1);
    } else if (m > 12) {
      datThang(1);
      datNam(nam + 1);
    } else datThang(m);
  };
  const lui = nam > nam0 || (nam === nam0 && thang > thang0);

  const bat = (ngay: string): void =>
    datChon((cu) => {
      const moi = new Set(cu);
      if (moi.has(ngay)) moi.delete(ngay);
      else moi.add(ngay);
      return moi;
    });

  return (
    <div className="man-che" role="presentation">
      <div className="hop-thoai lpt-lich" role="dialog" aria-modal="true" aria-labelledby={idTieuDe}>
        <div className="lpt-hop__dau">
          <h2 id={idTieuDe}>{tieuDe ?? t.tieuDe}</h2>
          <button type="button" className="lpt-hop__dong" aria-label={t.dong} onClick={onHuy}>
            ×
          </button>
        </div>
        <div className="lpt-lich__khung">
          <div className="lpt-lich__thang">
            <button type="button" aria-label={t.thangTruoc} disabled={!lui} onClick={() => doiThang(-1)}>
              ‹
            </button>
            <strong>{dienVao(t.thang, { thang, nam })}</strong>
            <button type="button" aria-label={t.thangSau} onClick={() => doiThang(1)}>
              ›
            </button>
          </div>
          <table className="lpt-lich__luoi">
            <thead>
              <tr>
                {t.thu.map((x) => (
                  <th key={x} scope="col">
                    {x}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {luoiThang(nam, thang).map((tuan, i) => (
                <tr key={i}>
                  {tuan.map((ngay, j) => {
                    if (!ngay) return <td key={j} />;
                    const daQua = ngay < homNay;
                    const daChon = chon.has(ngay) || tapCoDinh.has(ngay);
                    return (
                      <td key={j}>
                        <button
                          type="button"
                          className={`lpt-lich__ngay${daChon ? ' lpt-lich__ngay--chon' : ''}`}
                          data-ngay={ngay}
                          aria-pressed={daChon}
                          disabled={daQua || tapCoDinh.has(ngay)}
                          onClick={() => bat(ngay)}
                        >
                          {Number(ngay.slice(8))}
                        </button>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="lpt-hop__nut">
          <button type="button" className="nut lpt-nut-huy" onClick={onHuy}>
            {t.huy}
          </button>
          <button
            type="button"
            className="nut nut--chinh"
            data-hanh-dong="xac-nhan-ngay"
            disabled={chon.size === 0}
            onClick={() => onXacNhan([...chon].sort())}
          >
            {t.xacNhan}
          </button>
        </div>
      </div>
    </div>
  );
}
